
<template>
    <section class="hero is-fullheight" :class="{ 'rh-login': isRhRoute }">
        <div class="hero-body">
            <div class="container">
                <div class="columns is-centered">
                    <div class="column is-two-thirds">
                        <div class="box whitebox">
                            <div class="columns is-vcentered">
                                <div class="column is-7 is-spaced">
                                    <img v-if="isRhRoute" :src="rhLogo" alt="MetaVirtue" class="rh-login-logo" />
                                    <img v-else-if="config.logoBase64" :src="'data:image/png;base64, ' + config.logoBase64" />
                                </div>
                                <div class="column is-spaced">
                                    <div v-if="erros.length > 0" class="notification is-danger">
                                        <ul>
                                            <li v-for="(erro, index) in erros" v-bind:key="index">
                                                {{ erro }}
                                            </li>
                                        </ul>                                        
                                    </div>
                                    <form  @submit.prevent="onSubmit" method="post" role="form">
                                        <div v-if="!lostingPassword && !ReturnToken">
                                            <b-field label="Usuário">
                                                <b-input icon="account" required v-model="UserName"></b-input>
                                            </b-field>
                                            <b-field label="Senha">
                                                <b-input type="password" icon="lock" password-reveal required v-model="Password"></b-input>
                                            </b-field>
                                            <button type="submit" class="button is-primary is-fullwidth">Entrar</button>
                                            <br />
                                            <p class="has-text-centered is-size-7">
                                                <a @click="$router.push('/rh/recuperar')">Esqueceu a senha?</a>
                                            </p>                                            
                                        </div>
                                        <div v-else-if="!ReturnToken">

                                            <b-field label="E-mail">
                                                <b-input icon="account" required v-model="Email"></b-input>
                                            </b-field>
                                            <button type="submit" class="button is-primary is-fullwidth">Enviar</button>
                                            <button type="button" @click="cancelLostPassword()" class="button is-fullwidth">Voltar</button>
                                                                                                              
                                        </div>
                                        <div v-else>
                                            <b-field label="Nova Senha">
                                                <b-input type="password" icon="lock" password-reveal required v-model="Password"></b-input>
                                            </b-field>
                                            <b-field label="Confirmar Senha">
                                                <b-input type="password" icon="lock" password-reveal required v-model="ConfirmPassword"></b-input>
                                            </b-field>        
                                            <button type="submit" class="button is-primary is-fullwidth">Confirmar</button>                                                                                
                                        </div>

                                    </form>

                                                                      
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p v-if="!isRhRoute" class="has-text-centered is-italic">desenvolvido por <a target="blank" href="https://site.myclient.com.br/">MYCLIENT SISTEMAS</a></p>
            </div>            
        </div>
    </section>
</template>

<style scoped>
.is-spaced {
    padding: 1.5em;
}
.rh-login-logo { max-width: 320px; width: 100%; margin: auto; }
.rh-login { background: #F4F3F0; font-family: Montserrat, Arial, sans-serif; }
.rh-login .box { border-radius: 20px; box-shadow: 0 18px 55px rgba(11,26,62,.1); padding: 22px; }
.rh-login .button.is-primary { background: #007BFF; border-color: #007BFF; font-weight: 700; }
</style>

<script>
    import http from '@/http'
    import { mapActions, mapState } from 'vuex'
    import jwt from 'jsonwebtoken'
    import rhLogo from '@/assets/rh_logo.png'

    export default {
        data() {
            return {
                UserName: '',
                Password: '',
                Email: '',
                lostingPassword: false,
                ConfirmPassword: '',
                ReturnToken: null,                
                Token: null,
                GuiaId:null,
                UnidadeId:null,
                CodigoLote:null,
                AssistenciaId:null,
                Tipo:null
            }
        },
        computed: {
            rhLogo() { return rhLogo },
            isRhRoute() { return this.$route.path === '/rh' || this.$route.path.startsWith('/rh/') },
            ...mapState(['config', 'erros', 'usuario'])
        },
        mounted() { 
            setTimeout(() => {
                if (this.$route.query.email) this.Email = this.$route.query.email;
                if (this.$route.query.rt) this.ReturnToken = this.$route.query.rt;                                
                if (this.$route.query.user) this.UserName = this.$route.query.user;
                if (this.$route.query.pass) this.Password = this.$route.query.pass;

                /*
                if(this.UserName!=null && this.Password!=null 
                && this.UserName!='' && this.Password!='' 
                && this.UserName.length>1 && this.Password.length>1  ){
                    this.Password = atob(this.Password);
                    this.onSubmit();
                }
                */

                if (this.$route.query.token) {                    
                    this.Token = this.$route.query.token;
                    const json = jwt.decode(this.Token);
                    this.UserName = json.Nome;
                    this.GuiaId = json.GuiaId;
                    this.UnidadeId = json.UnidadeId;
                    this.CodigoLote = json.CodigoLote;
                    this.AssistenciaId = json.AssistenciaId;
                    this.Tipo = json.Tipo;
                    this.Password = "vazio";
                    this.onSubmit();
                }
                
            

            },500);                     

        },
        
        methods: {
            ...mapActions([
                'login',
                'commit'
            ]),
            lostPassword(){
                this.lostingPassword= true;
            },
            cancelLostPassword(){
                this.lostingPassword= false;
            },            
            onSubmit() {
                // se estiver num portal, sai
                if (this.$route.path.startsWith('/portal/')) {
                    this.$router.push('/')
                }


                if(this.ReturnToken){
                    http.post(`/api/auth/ResetPassword`, 
                    {
                        email : this.Email, 
                        returnToken: this.ReturnToken,
                        Password: this.Password,
                        ConfirmPassword: this.ConfirmPassword
                    }).then(res => res.data)
                      .then(data => {    
                            if(!data.mensagem){
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: "Nova senha foi definida com sucesso!",
                                    type: 'is-success',
                                    queue: false
                                });            
                                this.lostingPassword= false;
                                this.Email='';
                                this.UserName='';
                                this.Password='';
                                this.ConfirmPassword='';
                                this.ReturnToken=null;  

                                this.$router.replace('/');
                            }else{
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: data.mensagem,
                                    type: 'is-danger',
                                    queue: false
                                });                                            
                            }
                
                            
                        })
                        .catch((error) => {    

                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Ocorreu um erro!",
                                type: 'is-danger',
                                queue: false
                            });                                                    
                            throw error;

                        });                       

                } else if(!this.lostingPassword){


                    this.login({ authMethod: this.authMode, UserName: this.UserName, 
                        Password: this.Password, Token:this.Token, GuiaId:this.GuiaId, UnidadeId: this.UnidadeId, CodigoLote: this.CodigoLote, AssistenciaId: this.AssistenciaId })
                        .then(() => {   
                            if (!this.$store.state.isAuthenticated) return false;
                            const regras = this.$store.state.usuario.regras || [];
                            if (this.isRhRoute || regras.some(regra => regra === 'rh-diretoria' || regra === 'rh-lider' || regra === 'rh-colaborador')) {
                                if (this.$route.path !== '/rh') this.$router.replace('/rh');
                                return true;
                            }
                            if (this.AssistenciaId) {
                                this.$router.replace({ name: 'confirmacao_transportadora_assistencia', params: { assistenciaId: this.AssistenciaId } });
                            } else if (this.Tipo === 'TransportadoraEntregaAstec') {
                                this.$router.replace({ name: 'confirmacao_transportadora_entrega_astec', params: { codigoLote: this.CodigoLote } });
                            } else if (this.CodigoLote) {
                                this.$router.replace({ name: 'confirmacao_transportadora_entrega', params: { codigoLote: this.CodigoLote } });
                            } else {
                                this.$router.replace('/');
                            }
                            return true;                                     
                        });                    
                    
                }else{

                    http.post(`/api/auth/LostPassword`, {email : this.Email})
                        .then(res => res.data)
                        .then(data => {    
                            if(!data.mensagem){
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: "Email de Redefinição de senha foi enviado com sucesso!",
                                    type: 'is-success',
                                    queue: false
                                });            
                                this.lostingPassword= false;
                                this.Email='';
                            }else{
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: data.mensagem,
                                    type: 'is-danger',
                                    queue: false
                                });                                            
                            }
                
                            
                        })
                        .catch((error) => {    

                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Ocorreu um erro!",
                                type: 'is-danger',
                                queue: false
                            });                                                    
                            throw error;

                        });                    

                }

            }
        }
    }
</script>
